import Vue from 'vue';
import bus from '@/plugins/bus';

Vue.mixin({
  methods: {
    redirect(page, id = null) {
      if (id) {
        this.$router.push(`/${page}/${id}`);
        return;
      }

      this.$router.push(`/${page}`);
    },
    redirectNewTab(page, key = null) {
      if (key) {
        window.open(`/${page}/${key}`, '_blank');

        return;
      }

      window.open(`/${page}`, '_blank');
    },
    closeAll(el) {
      if (el.toElement.className != 'top-bar-add') {
        this.edit = this.create = false;
      }
    },
    closeUserForm() {
      bus.$on('closeUserForm', () => {
        this.edit = this.create = false;
      });
    }
  }
});
